import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ReadingTypeService from "../../../services/ReadingTypeService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListReadingType from "../Components/ListReadingType";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewReadingTypes() {
  const [readingTypes, setReadingTypes] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchReadingTypes();
  }, [currentPage]);

  const fetchReadingTypes = async () => {
    setLoading(true);
    try {
      const res = await ReadingTypeService.getAllPaginated(currentPage, itemsPerPage);

      if (res.status) {
        setReadingTypes(res.data || []);
        setPageCount(res.totalPages || 1);
      } else {
        showMessage("Failed to load reading types", "error");
      }
    } catch (err) {
      console.error(err);
      showMessage("Error fetching reading types", "error");
    } finally {
      setLoading(false);
    }
  };


  //   const fetchReadingTypes = async () => {
  //     setLoading(true);
  //     try {
  //       const res = await ReadingTypeService.getAll();
  //       if (res.success) {
  //         if (res.success) {
  //   const allData = res.data || [];
  //   const startIndex = (currentPage - 1) * itemsPerPage;
  //   const paginatedData = allData.slice(startIndex, startIndex + itemsPerPage);

  //   setReadingTypes(paginatedData);
  //   setPageCount(Math.ceil(allData.length / itemsPerPage));
  // }

  //       } else {
  //         showMessage("Failed to load reading types", "error");
  //       }
  //     } catch (err) {
  //       console.error(err);
  //       showMessage("Error fetching reading types", "error");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  const handleAdd = () => navigate("/cpnl/readingtype/add");

  const handleModify = () => {
    if (!selected) {
      showMessage("Please select one reading type to modify.");
      return;
    }
    navigate(`/cpnl/readingtype/add/${selected}`);
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Are you sure want to change status to ${newStatus}?`))
      return;

    try {
      await ReadingTypeService.updateStatus(id);

      setReadingTypes((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        )
      );

      showMessage(`Reading Type status updated to ${newStatus}`, "success");
    } catch (err) {
      console.error(err);
      showMessage("Failed to update status", "error");
    }
  };

  const getStatusClass = (status) =>
    status === "Active" ? "bg-success" : "bg-secondary";

  //  SEARCH FILTER (frontend)
  const filteredReadingTypes = readingTypes.filter((r) =>
    r.readingType.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Reading Types" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              ></button>
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {/*  SEARCH + ACTIONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Reading Type"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListReadingType
            loading={loading}
            filteredReadingTypes={filteredReadingTypes}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            getStatusClass={getStatusClass}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
